<template>
  <div class="donga-audit">
    <body bgcolor="#FFFFFF" leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">
    <table border="0" cellspacing="0" cellpadding="0">
        <tr>
            <td><img src="../img/systemCheck.jpg" usemap="#Map"  border="0"></td>
        </tr>
        <tr>
            <td height="20" bgcolor="#000000">
                <table width="95%" border="0" align="center" cellpadding="0" cellspacing="0">
                    <tr>
                        <td width="22">
                            <input type="checkbox" name="chkopen" value="checkbox" >
                        </td>
                        <td>
                            <button @click="closeWin2()"><img src="../img/tt.gif" width="140" height="10" border="0"></button>
                        </td>
                        <td align="right">
                            <button @click="closeWin()"><img src="../img/btn.gif" width="32" height="10" border="0"></button>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</div>
</template>

<script>
export default {
  name: 'AuditPopup2',
  methods: {
    setCookie (name, value, expiredays) {
      var todayDate = new Date()
      todayDate.setDate(todayDate.getDate() + expiredays)
      document.cookie = name + '=' + escape(value) + '; path=/; expires=' + todayDate.toUTCString() + ';'
    },
    closeWin () {
      if (document.all.chkopen.checked) {
        this.setCookie('popupname2', 'done', 1)
        self.close()
      } else {
        self.close()
      }
    },
    closeWin2 () {
      this.setCookie('popupname2', 'done', 1)
      self.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/AuditPopup2.vue